"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    checked: zod_1.z.boolean((0, validation_1.labelZodErrors)("Checkbox")).optional(),
});
const dataSchema = zod_1.z.object({
    checked: zod_1.z.boolean((0, validation_1.labelZodErrors)("Checkbox")),
});
exports.default = new ItemDefinition_1.ItemDefinition("Checkbox", configSchema, dataSchema, new validation_1.ValidatorPipeline("Checkbox Config Validator", []), new validation_1.ValidatorPipeline("Checkbox Data Validator", [
    (0, validation_1.createZodSchemaValidator)(["data", "checked"], zod_1.z.literal(true, (0, validation_1.labelZodErrors)("Checkbox"))),
]));
//# sourceMappingURL=Checkbox.js.map